import React from 'react'

export default React.memo(({ className, children }) => {
    return (
        <div className={(className ? className + ' ' : '') + 'container'}>
            <div className='row'>
                <div className='col-12'>{children}</div>
            </div>
        </div>
    )
})
